<!-- child component is made so that to pass the data  to different parent component  -->
<div fxLayout="column" fxLayoutAlign="center center" class="margin-1-0-rem"
    [ngStyle]="{'height': page == 'wf-run' ? '100%' : ''}">
    {{newData}}
</div>